import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { LoginService } from './login.service';

declare var $:any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  providers: [LoginService]
})
export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {

  userForm: FormGroup;
  prikaziLogin: boolean = true;
  obavijest: string = "";

  constructor(
    private _fb: FormBuilder,
    private _loginService: LoginService,
    public _router: Router
  ) { }

  ngOnInit() {
    $('body').addClass('empty-layout');
    this.userForm = this._fb.group({
      email: [''],
      password: ['']
    });
  }

  ngAfterViewInit() {
    $('#login-form').validate({
        errorClass: "help-block",
        rules: {
            email: {
                required: true,
                email: true
            },
            password: {
                required: true
            }
        },
        highlight: function(e) {
            $(e).closest(".form-group").addClass("has-error")
        },
        unhighlight: function(e) {
            $(e).closest(".form-group").removeClass("has-error")
        },
    });
  }

  ngOnDestroy() {
    $('body').removeClass('empty-layout');
  }

  loginSql(data:any){
    // localStorage.setItem('token', "testtoken");
    // localStorage.setItem('userId', "-");
    // localStorage.setItem('ime', "Vladimir");
    // localStorage.setItem('prezime', "Grebenar");
    // localStorage.setItem('slikaProfilaURL', "http://holspico.hr/wp-content/uploads/2018/12/slika.jpg");
    // this._router.navigate(['/index']);
    let objekt = {
      'email': data.email,
      'password': data.password
    };
       this._loginService.loginSql({'email': data.email, 'password': data.password}).subscribe(res => {
        //  console.log(res);
         if(res.success == true){
          // console.log(res.user);
          localStorage.setItem('tokenSql', res.user[0].token);
          // localStorage.setItem('token', "mongoDemoToken");
          localStorage.setItem('ime', res.user[0].ko_imeiprezime);
          localStorage.setItem('userId', res.user[0].idkorisnik);
          localStorage.setItem('slikaProfilaURL', "https://obitelji3plus.hr/wp-content/uploads/2019/09/Holspico_FINAL.png");
          //0-kor,1-a,2-pred
          localStorage.setItem('vrsta', res.user[0].ko_admin);
          if(res.user[0].ko_admin == 1 || res.user[0].ko_admin == 2){
             this._router.navigate(['/ucionica-popis']);
             if(data.email == 'admin@holspico.hr'){
              this.login(data);
             }
          } else {
            this._router.navigate(['/polaznik-ucionice']);
          }
          //Fizička ili pravna osoba
          // localStorage.setItem('ko_tipKorisnika', res.user[0].ko_imeiprezime);
          // this._router.navigate(['/index']);
          // this._router.navigate(['/ucionica-popis']);
         } else {
           alert(res['message'])
         }
     })
  }

  login(data:any){
    // console.log('Mongo login');
    let objekt = {
       'email': data.email,
       'password': data.password,
       'access_token': 'dfuV1TuPRuVFpiA1f6zbB9fB9vQqy4Kc'
    };
    // localStorage.setItem('token', "testtoken");
    // localStorage.setItem('userId', "-");
    // localStorage.setItem('ime', "Vladimir");
    // localStorage.setItem('prezime', "Grebenar");
    // localStorage.setItem('slikaProfilaURL', "http://holspico.hr/wp-content/uploads/2018/12/slika.jpg");
    // this._router.navigate(['/index']);
      this._loginService.login(objekt).subscribe(res => {
        // console.log(res);
        if(res['token']){
            localStorage.setItem('tokenMongo', res['token']);
            localStorage.setItem('userIdMongo', "-");
            localStorage.setItem('imeMongo', "Vladimir");
            localStorage.setItem('prezimeMongo', "Grebenar");
            localStorage.setItem('slikaProfilaURL', "http://holspico.hr/wp-content/uploads/2018/12/slika.jpg");
            // this._router.navigate(['/index']);
        } else {
          //  this.obavijest = "Neispravni podaci za prijavu!";  
        }
     })
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/login/login.component.ts